import styled from 'styled-components';

export const StyledTitleBadge = styled.span`
  .title-badge {
    display: inline-flex;
    text-transform: uppercase;
    padding: 6px 14px;
    letter-spacing: 2px;
    border: 1px solid ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.3)};
    background: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.06)};
    border-radius: 50px;
    width: min-content;
    white-space: nowrap;
  }
`;
